export default __webpack_public_path__ + "static/banner-finance-big-financial-e4c0fae402431cc4676134d4a6da1a99.jpg";